<template>
    <div class="grafana-page">
        <div class="d-flex align-items-center mb-3">
            <h1 class="page-header mb-0">{{ $t('str.form.title.grafana') }}</h1>
        </div>
        <hr />

        <panel :title="$t('str.form.title.grafana')" :noButton="true" panelClass="grafana-panel" bodyClass="grafana-panel-body">
            <div class="grafana-shell">
                <div v-if="isLoading" class="grafana-loading-overlay">
                    <div class="grafana-loading-card">
                        <i class="fas fa-spinner fa-spin grafana-state-icon" />
                        <p class="grafana-state-text mb-0">{{ $t('str.grafana.loading') }}</p>
                    </div>
                </div>

                <div v-if="showFallback" class="grafana-fallback">
                    <div class="alert alert-warning mb-3" role="alert">
                        <strong class="d-block mb-2">{{ $t(fallbackMessageKey) }}</strong>
                        <span>{{ $t('str.grafana.embed.blocked.help') }}</span>
                    </div>

                    <button type="button" class="btn btn-primary" :disabled="!grafanaUrl" @click="openGrafana">
                        <i class="fa fa-external-link-alt me-2"></i>
                        {{ $t('str.grafana.open') }}
                    </button>
                </div>

                <iframe
                    v-if="grafanaUrl && !showFallback"
                    v-show="iframeLoaded"
                    :src="grafanaUrl"
                    class="grafana-iframe"
                    title="Grafana"
                    frameborder="0"
                    @load="handleIframeLoad"
                    @error="handleIframeError"
                />
            </div>
        </panel>
    </div>
</template>

<script>
import Controller from './CrtGrafana.vue'

export default {
    name: 'Grafana',
    data() {
        return {
            grafanaUrl: '',
            isLoading: true,
            iframeLoaded: false,
            showFallback: false,
            fallbackMessageKey: 'str.grafana.embed.error',
            embedTimeoutId: null,
        }
    },
    methods: {
        ...Controller.methods,
    },
    mounted() {
        Controller.init(this)
    },
    beforeDestroy() {
        this.clearEmbedTimeout()
    },
}
</script>

<style>
.grafana-page {
    min-height: calc(100vh - 140px);
}

.grafana-panel-body {
    min-height: calc(100vh - 240px);
    padding: 0 !important;
    position: relative;
    overflow: hidden;
}

.grafana-shell {
    min-height: calc(100vh - 240px);
    height: calc(100vh - 240px);
    position: relative;
    overflow: hidden;
    background:
        radial-gradient(circle at top left, rgba(60, 92, 142, 0.18), transparent 32%),
        linear-gradient(135deg, #161a22 0%, #1f2430 100%);
}

.grafana-iframe {
    width: 100%;
    height: 100%;
    min-height: 100%;
    border: 0;
    display: block;
    background: #fff;
}

.grafana-loading-overlay,
.grafana-fallback {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 24px;
    text-align: center;
    z-index: 1;
}

.grafana-loading-card {
    min-width: min(420px, 100%);
    padding: 32px 28px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 18px;
    background: rgba(9, 12, 18, 0.68);
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.28);
    backdrop-filter: blur(12px);
}

.grafana-state-icon {
    font-size: 2rem;
    margin-bottom: 12px;
}

.grafana-state-text {
    color: rgba(255, 255, 255, 0.72);
}

.grafana-fallback .alert {
    max-width: 720px;
}

@media (max-width: 767.98px) {
    .grafana-page {
        min-height: auto;
    }

    .grafana-shell,
    .grafana-panel-body,
    .grafana-iframe,
    .grafana-loading-overlay,
    .grafana-fallback {
        min-height: calc(100vh - 220px);
        height: calc(100vh - 220px);
    }

    .grafana-loading-card {
        min-width: 100%;
    }
}
</style>
